import React from 'react';
import Page from './Page';
import {FancyButton, Icon} from '../widgets';
import FancyLink from '../widgets/FancyLink';
import {connect} from 'react-redux';
import {uiActions} from '../chrome/';
import './SchoolsPage.css';
import QuoteCard from '../widgets/QuoteCard';
import Carousel from '../widgets/Carousel';
import Explorer from '../widgets/Explorer';
import CalloutAside from '../widgets/CalloutAside';
import EmbeddedCommunityCard from '../community/EmbeddedCommunityCard';

export const SchoolsPage = ({signup}) => {
	return (
		<Page className="SchoolsPage fullwidth" title="B2Me for schools">
			<Carousel
				features={[
					{
						url: '/img/directory.jpg',
						highlight: 'Build a directory of businesses in your school community',
						lowlight: 'and make it available where your parents are.'
					},
					{
						url: '/img/schools-header-3.jpg',
						highlight: "Grow your school's brand",
						lowlight: 'and connect with your community.'
					},
					{
						url: '/img/schools-header-1.jpg',
						highlight: 'Give your school community somewhere to showcase their work',
						lowlight: 'and connect with, support, and engage with other providers.'
					},
					{
						url: '/img/schools-header-2.jpg',
						highlight: 'Connect your whole school community:',
						lowlight: 'students, parents, and staff.'
					},
					{
						url: '/img/st-georges.jpg',
						highlight: 'Support Alumni',
						lowlight: 'through encouraging contact between current and past residents.'
					}
				]}
			/>
			<section className="lefty">
				<h1>The platform helping school communities thrive</h1>
				<p>
					Connect local businesses with people in your school and reach untapped community
					potential.
				</p>
				<h2>Grow and nurture your school community</h2>
				<p>
					People like using service-providers they like, know, and trust. With B2Me for Schools, you
					have a tailored directory platform that connects staff, students, and parents. Rather than
					sift through unknown service-providers, school members can choose from professionals
					within the school community — professionals that have common interests and connections.
				</p>
			</section>
			<div className="SchoolsPage-feature">
				<div className="SchoolsPage-feature-cards">
					<QuoteCard
						disc={<img src="img/jason.jpg" alt="Jason Bartell" />}
						content={[
							<blockquote key="1">
								"It has been a good, strong internal community. Now we need people to see who we are
								outside these walls."
							</blockquote>,
							<cite key="2">
								Jason Bartell, Principal John Septimus Roe Anglican Community School, Perth
							</cite>
						]}
					/>
					<QuoteCard
						disc={<img src="img/michelle.jpg" alt="Michelle Cronin" />}
						content={[
							<blockquote key="1">
								"The desire for community is definitely embedded into our nature and you have been
								able to link that desire with technology. Thank you B2Me team!."
							</blockquote>,
							<cite key="2">Michelle Cronin, Foundation Christian College, Mandurah</cite>
						]}
					/>
					<QuoteCard
						disc={<img src="img/mick.jpg" alt="Mick Lee" />}
						content={[
							<blockquote key="1">
								"It's a novel approach and one which I am stoked to be involved in from the early
								days."
							</blockquote>,
							<cite key="2">Mick Lee, Mick Lee Photography</cite>
						]}
					/>
				</div>
			</div>
			<section className="lefty">
				<h1>So much more than a directory</h1>
				<p>
					Through our platform, schools across Australia are cultivating thriving communities. It’s
					a business directory, but it’s so much more than that. These are just some of the
					benefits:
				</p>
			</section>
			<Explorer
				items={[
					{
						aside: (
							<span>
								<strong>Integrate your curriculum</strong>. With many parents running their own
								businesses, there are opportunities for students to access extra-curricular
								activities, work experience, internships, and apprenticeships.
							</span>
						),
						rightImg: '/img/schools-iphone.jpg',
						rightImgAlt: 'Screenshots of various B2Me pages on mobile phones',
						rightImgFancy: false
					},
					{
						aside: (
							<span>
								<strong>Promote upcoming events</strong>, such as parent nights, assemblies,
								fundraisers, sports carnivals, and more, through your digital noticeboard.
							</span>
						),
						leftImg: '/img/schools-explore-notices.png',
						leftImgAlt: "Example of a notice from a school's page on B2Me"
					},
					{
						aside: (
							<span>
								<strong>Say goodbye to Facebook</strong> groups and pages where parents constantly
								ask to advertise their businesses — that's what B2Me for Schools was made for!
							</span>
						),
						leftImg: '/img/schools-explore-profile.png',
						leftImgAlt: 'Example of a B2Me profile'
					},
					{
						aside: (
							<span>
								<strong>Give parents the opportunity</strong> to be active in the school by
								contributing their unique skillsets, such as maintenance, gardening, or trade-based
								services.
							</span>
						),
						rightImg: '/img/schools-explore-members.png',
						rightImgAlt: "Member cards from a school's B2Me page"
					},
					{
						aside: (
							<span>
								<strong>Build your brand</strong> outside the school walls and showcase your
								community.
							</span>
						),
						leftImg: '/img/schools-explore-brand.png',
						leftImgAlt: "Part of a school's page on B2Me"
					}
				]}
			/>
			<section className="lefty">
				<h1>See how schools are using us</h1>
				<ul className="row">
					<EmbeddedCommunityCard
						uniqueName={
							process.env.NODE_ENV === 'development' ? 'craige' : 'mandurah-baptist-college'
						}
						linkToMembers={true}
					/>
					<EmbeddedCommunityCard
						uniqueName={
							process.env.NODE_ENV === 'development'
								? 'woodvale-bap'
								: 'peter-moyes-anglican-community-school'
						}
						linkToMembers={true}
					/>
					<EmbeddedCommunityCard
						uniqueName={
							process.env.NODE_ENV === 'development'
								? 'woodvale-bap'
								: 'prendiville-catholic-college-the-hub'
						}
						linkToMembers={true}
					/>
					<EmbeddedCommunityCard
						uniqueName={
							process.env.NODE_ENV === 'development' ? 'woodvale-bap' : 'st-georges-college'
						}
						linkToMembers={true}
					/>
				</ul>
			</section>

			<section className="lefty">
				<h1>B2Me works for everyone</h1>
				<p>
					Need to know what to say to your school’s decision maker? We’ve made that easy as well.
				</p>
				<h2>Principals</h2>
				<p>
					B2Me for Schools is a revolutionary community-building tool bringing staff, parents,
					students, and alumni together, fostering valuable relationships. Schools can create and
					grow a trusted marketplace of local service-providers who sow back into the school
					community.
				</p>
				<p>
					Schools can implement their own policies and have full control over who can join the
					platform. In terms of “bad providers”, your school is simply a vehicle collating service-
					providers in your school in one place. The onus is on individuals to do their own
					assessments on the service-provider they choose.
				</p>
				<h2>Deputies</h2>
				<p>
					Our platform has organically evolved to support VET opportunities for students. Many
					parents run their own businesses and are excited to support students with extra-curricular
					activities, work experience, internships, and apprenticeships. By integrating B2Me for
					Schools with your curriculum, students can complete secondary education requirements
					alongside parents they like, know, and trust.
				</p>
				<h2>Bursars</h2>
				<p>
					Save your school time and money. With B2Me for Schools, labour-intensive, traditional
					school directories and their tedious updates are a thing of the past. Service-providers
					build your online network for you and keep it up-to-date.
				</p>
				<h2>Marketers</h2>
				<p>
					Your B2Me for School profile can be opened up to the community outside the school walls.
					You’re able to create additional touchpoints within the local area and increase engagement
					among stakeholders. Build credibility, increase brand-awareness, and be noticed as a
					community-minded school to drive enrolments.
				</p>
				<p>
					Rather than relying on Facebook, parents are able to advertise their business through our
					platform. Individuals can leave ratings and review on services they’ve used to inform
					other users. You can also promote events through our digital noticeboard.
				</p>
			</section>
			<CalloutAside
				primary={
					<audio controls>
						<source src="/media/b2me-sue-myc-chris-greenwood-talk.mp3" type="audio/mpeg" />
						<source src="/media/b2me-sue-myc-chris-greenwood-talk.ogg" type="audio/ogg" />
						<p>
							Your browser does not support HTML5 audio, but you can still
							<a href="/media/b2me-sue-myc-chris-greenwood-talk.mp3">download the music</a>.
						</p>
					</audio>
				}
				aside={
					<p>
						Listen to CEO and Founder of B2Me{' '}
						<a href="https://b2me.com.au/@ray-bartell">Ray Bartell</a> chat with{' '}
						<a href="https://b2me.com.au/@chris-greenwood5715">Chris Greenwood</a> from Prendiville
						Catholic College and Sue Myc on 89.7FM.
					</p>
				}
			/>

			<section class="call-to-action">
				<a
					className="SchoolsPage-call-to-action"
					target="_blank"
					rel="noopener noreferrer"
					href="https://share.hsforms.com/1IpKFZ73dRjyHzG9ZGQkoPw2gqzs">
					<p className="secondary">Find out how to get started with B2Me</p>
					<p className="primary">Get in touch</p>
				</a>
				<a
					className="SchoolsPage-call-to-action"
					href="/b2me-schools-flyer.pdf"
					target="_blank"
					rel="noopener noreferrer">
					<p className="secondary">Download the B2Me for Schools Flyer</p>
				</a>
			</section>

			<section>
				<video poster="/media/b2meschools.png" preload="meta" controls width="750">
					<source src="/media/b2meschools.mp4" type="video/mp4" />
					<source src="/media/b2meschools.ogg" type="video/ogg" />
				</video>
			</section>
		</Page>
	);
};

const ConnectedSchoolsPage = connect(
	() => ({}),
	dispatch => ({
		signup: () => dispatch(uiActions.uiModal('signup'))
	})
)(SchoolsPage);

export default ConnectedSchoolsPage;



// WEBPACK FOOTER //
// ./src/pages/SchoolsPage.js